import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Cabserviceinhadapsar() {



    const cardData = {

keyword: "Cab Service in Hadapsar",

headingDescription:
    "Rising Cab Service offers reliable and affordable Cab Service in Hadapsar for IT professionals, daily commuters, families, and business travelers. We provide quick local rides, airport transfers, railway station drops, and comfortable outstation travel from Hadapsar to all major destinations. Our fleet includes well-maintained Sedan, SUV, Innova Crysta, Tempo Traveller, and Urbania vehicles driven by professional and verified chauffeurs. With 24/7 availability, on-time pickup, and transparent pricing, Rising Cab Service ensures a safe, smooth, and hassle-free travel experience in Hadapsar and nearby areas.",

topPlaces: [
  
    {
        title: "Khandala",
        description:
            " attracts travelers with its dramatic cliffs, foggy mountains, and iconic viewpoints such as Tiger’s Leap. Located close to Lonavala, it offers quick road-trip access from Pune for a refreshing break. Scenic drives, monsoon landscapes, and peaceful hill views make it a favorite among weekend explorers."
    },
    {
        title: "Lavasa",
        description:
            " features a planned lakeside township designed with colorful architecture inspired by European towns. Visitors enjoy relaxed walks along the promenade, boating activities, and resort stays surrounded by hills. Its calm environment makes it suitable for family outings and short leisure trips from Pune."
    },
      {
        title: "Lonavala",
        description:
            " stands out as one of the most visited weekend escapes from Pune, surrounded by lush valleys, waterfalls, and misty hills. Monsoon season transforms the entire region into a green paradise, making it ideal for nature walks, short treks, and photography. Local attractions, caves, and famous chikki shops add to the overall travel experience."
    },
    {
        title: "Mahabaleshwar",
        description:
            " draws tourists with its cool climate, dense forests, and breathtaking viewpoints across the Western Ghats. Strawberry farms, waterfalls, and boating spots enhance the overall hill-station experience. The region offers a perfect mix of nature, sightseeing, and relaxed holiday vibes."
    },
    {
        title: "Panchgani",
        description:
            " offers a calm hill-station experience centered around the vast Table Land plateau and scenic valley views. Strawberry farms, colonial-era charm, and pleasant weather create a peaceful environment for families and couples. Its slower pace makes it ideal for unwinding away from city life."
    },
    {
        title: "Alibaug",
        description:
            " brings a coastal escape with clean beaches, historic sea forts, and refreshing sea breeze experiences. Ferry rides and beachside activities add adventure and fun to short trips from Pune. Fresh seafood and sunset views enhance the relaxed coastal atmosphere."
    },
    {
        title: "Matheran",
        description:
            " provides a unique pollution-free hill retreat where vehicles are completely banned, preserving its natural charm. Dense forests, toy train rides, and multiple viewpoints offer scenic walking trails throughout the region. Its quiet surroundings make it perfect for slow, nature-focused travel."
    },
    {
        title: "Bhimashankar",
        description:
            " combines spiritual importance with natural beauty, located deep within the Western Ghats. The temple attracts pilgrims while surrounding forests provide trekking routes and wildlife sightings. Its peaceful environment makes it both a religious and nature-friendly destination."
    },
    {
        title: "Tapola",
        description:
            " offers a quiet lakeside escape often called the Mini Kashmir of Maharashtra, surrounded by calm waters and green hills. Boating, camping, and photography are popular activities in this serene environment. Its less crowded nature makes it perfect for peaceful weekend retreats."
    },
    {
        title: "Kolad",
        description:
            " delivers an adventure-packed experience centered around white-water rafting on the Kundalika River. Monsoon season boosts water levels, making it a hotspot for thrill-seekers and group trips. Camping, kayaking, and riverside stays complete the outdoor adventure feel."
    }
],



services: [
    {
        name: "Taxi Service in Hadapsar",
        description:
            "Rising Cab Service offers Taxi Service in Hadapsar for daily commuters, IT professionals, families, and business travelers looking for safe, reliable, and comfortable transportation. We provide well-maintained AC vehicles, experienced drivers, and 24x7 availability for local travel, airport transfers, corporate commutes, and outstation journeys. Our focus is on punctual service, smooth rides, and affordable pricing across Hadapsar and Pune city."
    },
    {
        name: "Hadapsar Cab Service",
        description:
            "Our Hadapsar Cab Service ensures quick, safe, and convenient transportation for residents, corporate employees, and tourists. Rising Cab Service offers clean vehicles, professional chauffeurs, and flexible booking options for daily commuting, office travel, and intercity trips with complete reliability and comfort."
    },
    {
        name: "Hadapsar Taxi Service",
        description:
            "Rising Cab Service provides Hadapsar Taxi Service with comfortable and affordable rides across Pune and Maharashtra. Whether it is a short city trip or a long-distance journey, our experienced drivers ensure safe travel, timely pickup, and customer satisfaction for all passengers."
    },
    {
        name: "Best Cab Service in Hadapsar",
        description:
            "Book Best Cab Service in Hadapsar with Rising Cab Service for premium transportation, transparent pricing, and 24x7 support. We offer high-quality service with well-maintained vehicles and professional drivers suitable for families, corporate clients, and solo travelers."
    },
    {
        name: "Online Cab Booking Hadapsar",
        description:
            "Our Online Cab Booking Hadapsar system allows quick and easy cab reservations with instant confirmation, multiple vehicle options, and transparent pricing. Rising Cab Service ensures a seamless booking experience for both local and outstation travel needs."
    },
    {
        name: "Cab Hire in Hadapsar",
        description:
            "Rising Cab Service offers Cab Hire in Hadapsar for hourly rentals, full-day trips, corporate travel, and personal transportation needs. We provide flexible packages with professional drivers and comfortable vehicles for a smooth travel experience."
    },
    {
        name: "Taxi Booking Hadapsar",
        description:
            "Book Taxi Booking Hadapsar with Rising Cab Service for fast, reliable, and affordable transportation. We ensure timely service, clean vehicles, and experienced drivers for all types of travel requirements including local and outstation trips."
    },
    {
        name: "Outstation Cab Service Hadapsar",
        description:
            "Rising Cab Service provides Outstation Cab Service Hadapsar for long-distance travel to popular destinations like Mumbai, Shirdi, Nashik, Goa, Mahabaleshwar, Kolhapur, Pandharpur, Bhimashankar, and Aurangabad. We offer comfortable rides, experienced drivers, and flexible one-way or round-trip options."
    },
    {
        name: "Cab Service Near Magarpatta City",
        description:
            "Rising Cab Service provides Cab Service Near Magarpatta City for IT professionals and residents with quick pickups, safe rides, and reliable transportation for daily and corporate travel needs."
    },
    {
        name: "Taxi Service Near Magarpatta City",
        description:
            "Our Taxi Service Near Magarpatta City ensures fast and convenient travel for employees, families, and visitors with professional drivers and comfortable vehicles available 24x7."
    },
    {
        name: "Cab Service Near SP Infocity Hadapsar",
        description:
            "Rising Cab Service offers Cab Service Near SP Infocity Hadapsar for corporate employees with timely pickups, clean vehicles, and safe transportation for office commuting."
    },
    {
        name: "Taxi Service Near SP Infocity Pune",
        description:
            "Book Taxi Service Near SP Infocity Pune with Rising Cab Service for reliable corporate travel, daily office commutes, and comfortable rides with experienced drivers."
    },
    {
        name: "Cab Service Near Amanora Park Town",
        description:
            "Rising Cab Service provides Cab Service Near Amanora Park Town for residents and visitors with quick availability, safe rides, and affordable pricing for all travel needs."
    },
    {
        name: "Cab Service Near Cybercity Hadapsar",
        description:
            "Our Cab Service Near Cybercity Hadapsar ensures smooth and timely transportation for IT professionals with well-maintained vehicles and professional drivers."
    },
    {
        name: "Employee Cab Service Magarpatta",
        description:
            "Rising Cab Service offers Employee Cab Service Magarpatta for corporate staff commuting with safe, punctual, and reliable transportation solutions designed for daily office travel."
    },
    {
        name: "Corporate Cab Service SP Infocity",
        description:
            "Book Corporate Cab Service SP Infocity with Rising Cab Service for professional employee transport, business travel, and corporate mobility solutions with high reliability."
    },
    {
        name: "Hadapsar to Mumbai Cab",
        description:
            "Rising Cab Service provides Hadapsar to Mumbai Cab for safe and comfortable intercity travel with experienced drivers, smooth highway rides, and flexible booking options."
    },
    {
        name: "Hadapsar to Shirdi Cab",
        description:
            "Book Hadapsar to Shirdi Cab with Rising Cab Service for a peaceful pilgrimage journey to Sai Baba temple with clean vehicles and reliable service."
    },
    {
        name: "Hadapsar to Nashik Cab",
        description:
            "Our Hadapsar to Nashik Cab service ensures safe and comfortable travel for family trips, pilgrimages, and business journeys with professional drivers."
    },
    {
        name: "Hadapsar to Goa Cab",
        description:
            "Rising Cab Service provides Hadapsar to Goa Cab for a relaxing beach vacation with safe driving, comfortable vehicles, and smooth long-distance travel experience."
    },
    {
        name: "Hadapsar to Mahabaleshwar Cab",
        description:
            "Book Hadapsar to Mahabaleshwar Cab for scenic hill station travel with experienced chauffeurs and comfortable rides suitable for families and couples."
    },
    {
        name: "Hadapsar to Lonavala Cab",
        description:
            "Rising Cab Service offers Hadapsar to Lonavala Cab for quick weekend getaways with safe, affordable, and comfortable transportation options."
    },
    {
        name: "Hadapsar to Kolhapur Cab",
        description:
            "Our Hadapsar to Kolhapur Cab service ensures smooth pilgrimage and family travel with reliable drivers and well-maintained vehicles."
    },
    {
        name: "Hadapsar to Pandharpur Cab",
        description:
            "Rising Cab Service provides Hadapsar to Pandharpur Cab for devotees visiting Lord Vitthal temple with comfortable and safe travel arrangements."
    },
    {
        name: "Hadapsar to Bhimashankar Cab",
        description:
            "Book Hadapsar to Bhimashankar Cab for a spiritual Jyotirlinga pilgrimage with safe driving and experienced chauffeurs."
    },
    {
        name: "Hadapsar to Aurangabad Cab",
        description:
            "Rising Cab Service offers Hadapsar to Aurangabad Cab for heritage and tourism travel with professional drivers and reliable intercity service."
    },
    {
        name: "Innova Crysta on Rent in Hadapsar",
        description:
            "Book Innova Crysta on Rent in Hadapsar with Rising Cab Service for premium comfort, spacious seating, and luxury travel experience ideal for family and group trips."
    },
    {
        name: "Ertiga Cab Service Hadapsar",
        description:
            "Rising Cab Service provides Ertiga Cab Service Hadapsar for affordable and comfortable family travel with clean vehicles and professional drivers."
    },
    {
        name: "Swift Dzire Cab Service Hadapsar",
        description:
            "Our Swift Dzire Cab Service Hadapsar offers economical and comfortable rides ideal for daily commuting, city travel, and short-distance trips."
    }
],

tableData: [
    ["Taxi Service in Hadapsar", "Hadapsar Cab Service"],
    ["Hadapsar Taxi Service", "Best Cab Service in Hadapsar"],
    ["Online Cab Booking Hadapsar", "Cab Hire in Hadapsar"],
    ["Taxi Booking Hadapsar", "Outstation Cab Service Hadapsar"],
    ["Cab Service Near Magarpatta City", "Taxi Service Near Magarpatta City"],
    ["Cab Service Near SP Infocity Hadapsar", "Taxi Service Near SP Infocity Pune"],
    ["Cab Service Near Amanora Park Town", "Cab Service Near Cybercity Hadapsar"],
    ["Employee Cab Service Magarpatta", "Corporate Cab Service SP Infocity"],
    ["Hadapsar to Mumbai Cab", "Hadapsar to Shirdi Cab"],
    ["Hadapsar to Nashik Cab", "Hadapsar to Goa Cab"],
    ["Hadapsar to Mahabaleshwar Cab", "Hadapsar to Lonavala Cab"],
    ["Hadapsar to Kolhapur Cab", "Hadapsar to Pandharpur Cab"],
    ["Hadapsar to Bhimashankar Cab", "Hadapsar to Aurangabad Cab"],
    ["Innova Crysta on Rent in Hadapsar", "Ertiga Cab Service Hadapsar"],
    ["Swift Dzire Cab Service Hadapsar", "Cab Service Near Magarpatta City"]
],





whychoose: [
    {
        WhyChooseheading: "Convenient Travel Solutions in Hadapsar",
        WhyChoosedescription: "Rising Cab Service offers reliable transportation services for residents, professionals, students, and visitors traveling within Hadapsar and surrounding areas."
    },
    {
        WhyChooseheading: "Preferred by IT and Business Professionals",
        WhyChoosedescription: "Employees working in Magarpatta City, SP Infocity, Amanora, and nearby business hubs trust our cab services for daily commuting and official travel."
    },
    {
        WhyChooseheading: "Suitable for Local and Long-Distance Journeys",
        WhyChoosedescription: "From city rides and airport transfers to outstation trips and weekend tours, our services cater to a wide variety of travel requirements."
    },
    {
        WhyChooseheading: "Vehicle Options for Every Travel Plan",
        WhyChoosedescription: "Customers can choose from Sedan cars, Ertiga, Innova Crysta, SUVs, Tempo Travellers, and premium vehicles depending on their travel needs."
    },
    {
        WhyChooseheading: "Quick Pickup from Major Locations",
        WhyChoosedescription: "Our cabs are available for pickup from residential societies, offices, shopping centers, hospitals, hotels, and important landmarks across Hadapsar."
    },
    {
        WhyChooseheading: "Flexible Travel Scheduling",
        WhyChoosedescription: "Whether you require a ride early in the morning, during office hours, or late at night, our service adapts to your preferred timing."
    },
    {
        WhyChooseheading: "Focus on Passenger Comfort",
        WhyChoosedescription: "Clean interiors, air-conditioned vehicles, and courteous drivers help create a pleasant travel experience for every customer."
    },
    {
        WhyChooseheading: "Trusted for Family and Corporate Travel",
        WhyChoosedescription: "Rising Cab Service is a popular choice for family outings, business meetings, airport transportation, and group travel arrangements."
    }
]
};

const faqData = [
    {
        question: "Which important areas can be reached from Hadapsar using your cab service?",
        answer: "Customers frequently travel to Magarpatta, Amanora, Kharadi, Viman Nagar, Pune Airport, Hinjewadi, Baner, and various outstation destinations."
    },
    {
        question: "Is airport transportation available from Hadapsar?",
        answer: "Yes, we provide timely pickup and drop services between Hadapsar and Pune Airport."
    },
    {
        question: "Can office employees arrange transportation for daily travel?",
        answer: "Yes, our services are commonly used by professionals working in IT parks and commercial centers."
    },
    {
        question: "What types of vehicles are available for booking?",
        answer: "We offer Sedan cars, SUVs, Ertiga, Innova Crysta, Tempo Travellers, and larger vehicles for group travel."
    },
    {
        question: "Do you provide transportation for outstation tours?",
        answer: "Yes, customers can book cabs from Hadapsar to destinations across Maharashtra and neighboring states."
    },
    {
        question: "Can families book larger vehicles for vacations and functions?",
        answer: "Yes, spacious vehicles and Tempo Travellers are available for family trips, weddings, and special occasions."
    },
    {
        question: "Are business travelers among your regular customers?",
        answer: "Yes, many executives and corporate employees use our service for meetings, conferences, and official travel."
    },
    {
        question: "Is it possible to reserve a cab for an entire day?",
        answer: "Yes, full-day cab bookings are available for local travel, business visits, sightseeing, and personal requirements."
    },
    {
        question: "Do you provide one-way and round-trip travel options?",
        answer: "Yes, both one-way and return-trip bookings can be arranged according to customer preferences."
    },
    {
        question: "How can customers schedule a cab from Hadapsar?",
        answer: "Reservations can be made through phone calls, WhatsApp messages, or online inquiries with Rising Cab Service."
    }
];

const testimonials = [
    {
        id: 1,
        name: "Mr. Pravin Jadhav",
        feedback:
            "Managing daily travel between Hadapsar and various business locations has become effortless. The service is punctual, comfortable, and consistently reliable.",
        rating: 5
    },
    {
        id: 2,
        name: "Mrs. Neha Bhosale",
        feedback:
            "A recent airport transfer and family outing were handled professionally. The driver was polite, the vehicle was spotless, and the journey was very comfortable.",
        rating: 5
    }
];













    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Darshan Cab", link: "Pune-Darshan-Cab" },
        { place: "/images/keyword/2.jpg", text: "Pune to Bhimashankar Cab", link: "Pune-to-Bhimashankar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad to Bhimashankar Cab", link: "Pimpri-Chinchwad-to-Bhimashankar-Cab" },
        { place: "/images/keyword/4.jpg", text: "Pune to Jejuri Cab", link: "Pune-to-Jejuri-Cab" },
        { place: "/images/keyword/5.jpg", text: "Pune Weekend Tour Packages", link: "Pune-Weekend-Tour-Packages" },
        { place: "/images/keyword/6.jpg", text: "Pune Darshan Packages", link: "Pune-Darshan-Packages" },
        { place: "/images/keyword/7.jpg", text: "Pune Sade Teen Shakti Peeth Bus on Rent", link: "Pune-Sade-Teen-Shakti-Peeth-Bus-on-Rent" },
        { place: "/images/keyword/8.jpg", text: "Pune Darshan Tempo Traveller on Rent", link: "Pune-Darshan-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/9.jpg", text: "Pune to Mysore Ooty Cab Package", link: "Pune-to-Mysore-Ooty-Cab-Package" },
        { place: "/images/keyword/10.jpg", text: "Pune to Mumbai Darshan Package", link: "Pune-to-Mumbai-Darshan-Package" },
        { place: "/images/keyword/11.jpg", text: "Pune to Ajanta Ellora Cab Service", link: "Pune-to-Ajanta-Ellora-Cab-Service" },
        { place: "/images/keyword/12.jpg", text: "Pune to Shirdi Darshan Package", link: "Pune-to-Shirdi-Darshan-Package" },
        { place: "/images/keyword/13.jpg", text: "Pune to Pandharpur Darshan", link: "Pune-to-Pandharpur-Darshan" },
        { place: "/images/keyword/14.jpg", text: "Hinjewadi Cab Service", link: "Hinjewadi-Cab-Service" },
        { place: "/images/keyword/15.jpg", text: "Cab Service in Wakad", link: "Cab-Service-in-Wakad" },
        { place: "/images/keyword/16.jpg", text: "Cab Service in Baner Pune", link: "Cab-Service-in-Baner-Pune" },
        { place: "/images/keyword/17.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
        { place: "/images/keyword/18.jpg", text: "Cab Service in Hadapsar", link: "Cab-Service-in-Hadapsar" },
        { place: "/images/keyword/19.jpg", text: "Cab Service in Viman Nagar", link: "Cab-Service-in-Viman-Nagar" },
        { place: "/images/keyword/20.jpg", text: "Cab Service in Kothrud", link: "Cab-Service-in-Kothrud" },
        { place: "/images/keyword/21.jpg", text: "Cab Service in Pimpri Chinchwad", link: "Cab-Service-in-Pimpri-Chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Cab Service in Wagholi Pune", link: "Cab-Service-in-Wagholi-Pune" },
        { place: "/images/keyword/23.jpg", text: "Pune to Trimbakeshwar Cab", link: "Pune-to-Trimbakeshwar-Cab" },
        { place: "/images/keyword/24.jpg", text: "Cab Service in Pune", link: "Cab-Service-in-Pune" },
        { place: "/images/keyword/25.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
    ];















const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Cab Service in Hadapsar",
"image": "https://www.risingcabservice.com/assets/images/cab-service-in-hadapsar.jpg",
"description": "Book Cab Service in Hadapsar with Rising Cab Service for local travel, airport transfers, corporate commuting, and outstation trips. Enjoy safe, affordable, and reliable taxi service near Magarpatta City, Amanora Park Town, and SP Infocity.",
"brand": {
"@type": "Brand",
"name": "Rising Cab Service"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "5471"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹14/Km",
"availability": "https://schema.org/InStock",
"url": "https://www.risingcabservice.com/cab-service-in-hadapsar"
}
};



    return (
        <div>



<Helmet>
  <title>Cab Service in Hadapsar | Magarpatta & Amanora Taxi | +91 9272511548</title>

<meta
 name="description"
 content="Book Cab Service in Hadapsar for local travel, airport transfers, corporate rides, and outstation trips. Reliable taxi service near Magarpatta City, Amanora Park Town, Cybercity, and SP Infocity."
/>

<meta
 name="keywords"
 content="Taxi Service in Hadapsar, Hadapsar Cab Service, Hadapsar Taxi Service, Best Cab Service in Hadapsar, Online Cab Booking Hadapsar, Cab Hire in Hadapsar, Taxi Booking Hadapsar, Outstation Cab Service Hadapsar, Cab Service Near Magarpatta City, Taxi Service Near Magarpatta City, Cab Service Near SP Infocity Hadapsar, Taxi Service Near SP Infocity Pune, Cab Service Near Amanora Park Town, Cab Service Near Cybercity Hadapsar, Employee Cab Service Magarpatta"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>
            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('./img/bg/breadcrumb-bg.jpg')",
                    position: "relative",
                }}
            >
                <div
                    style={{
                        position: "absolute",
                        inset: 0,
                        backgroundColor: "rgba(0,0,0,0.3)",
                        zIndex: 1,
                    }}></div>

                <div className="container" style={{ position: "relative", zIndex: 2 }}>
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title"> {cardData.keyword}</h1>
                    </div>
                </div>
            </div>




















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/18.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#FF681A', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Rising Cab Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Rising Cab Service</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Rising Cab Service </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919272511548" className="pc-call">+91 9272511548</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919272511548"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919272511548" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@risingcabservice.com" className="pc-email">
                                            booking@risingcabservice.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Rising Cab Service</strong><br />

                                            A Unit of Atithya Dining LLP,
                                            901, 902 Deron Height, Baner Rd,
                                            Above Ranka Jewelers, Pune,
                                            Maharashtra -411069
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Cabserviceinhadapsar;